import React, { Component } from 'react'
import Sidebar from '../multi/Sidebar'
import Calendar from '../multi/Calendar'

class Events extends Component {
  render = () => {

    return (
      <div>
        <div className="heroEvents vh-25 flex justify-end vh-50-ns">
        </div>
        <div id="maincontent" className="w-100 pa2 bg-moon-gray flex flex-column flex-row-l items-start-l">
          <Sidebar/>
          <Calendar/>
        </div>
      </div>
    )
  }
}

export default Events


// WEBPACK FOOTER //
// ./src/components/pages/EventsCalendar.js